module.exports = __webpack_public_path__ + "static/media/laucher_2_bg.6a95e26f.jpg";